import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Flex, Box, Text, Button, getPaletteColor } from 'pcln-design-system'
import { FooterHint } from '@pcln/date-picker'

const BorderBox = styled(Box)`
  border: solid ${(props) => getPaletteColor(props.border)(props)} 1px;
  border-radius: 6px;
  min-width: 70px;
`

const FooterFlex = styled(Flex)`
  z-index: 1000;
  border-top: 1px solid ${getPaletteColor('border.base')};
  height: auto;
`

const renderDollarSigns = (n) => Array(n + 2).join('$')

const CustomFooterWithColorCode = ({ dismissCalendar, lowestPrice, showLegend }) => (
  <FooterFlex p={3} width={[1]} alignItems='center' bg='background.lightest'>
    <Box mr={3}>
      <FooterHint />
    </Box>
    {lowestPrice &&
      showLegend &&
      [
        { price: lowestPrice, color: 'pricePrimary' },
        { price: lowestPrice + 50, color: 'caution' },
        { price: lowestPrice + 100, color: 'warning' },
      ].map((priceRange, index) => (
        <BorderBox
          color={`${priceRange.color}.light`}
          border={`${priceRange.color}.base`}
          mx={1}
          py='10px'
          key={priceRange.color}
          aria-label={`Price range $${priceRange.price}+`}
        >
          <Text textAlign='center' bold>
            {lowestPrice === Infinity ? renderDollarSigns(index) : `$${priceRange.price}+`}
          </Text>
        </BorderBox>
      ))}
    <Button onClick={dismissCalendar} size='medium' aria-label='Done' ml='auto' color='secondary.base'>
      Done
    </Button>
  </FooterFlex>
)

CustomFooterWithColorCode.propTypes = {
  dismissCalendar: PropTypes.func,
  lowestPrice: PropTypes.number,
  showLegend: PropTypes.bool,
}

export default CustomFooterWithColorCode
